export enum Partners {
  CDEK = 'cdek',
  SMARTSHELL = 'smartshell',
  GLOBALTRADE = 'globaltrade',
  INTERVALE = 'intervale',
  CITORA = 'citora',
  WILDBERRIES = 'wildberries',
  WILDBERRIES2 = 'wildberries2',
  VANTA = 'vanta',
  PLATOSFERA = 'platosfera',
  BANKIROS = 'bankiros',
  WHITE = 'white',
  MEGAFON = 'megafon',
  GENBANK = 'genbank',
  DEFAULT = 'default',
}
